/**
 * Section size policy for `sectioned-v1` documents.
 *
 * These are contract numbers, not local tuning knobs: the editor's split
 * warning, the server's `needs_rebalance` flag and the maintenance rebalancer
 * all have to agree on the same boundaries. If the client warned at a different
 * size than the server flags, operators would page on sections that every author
 * reports as healthy.
 *
 * 256 KiB is the target a rebalance aims for, 768 KiB is where we start asking
 * the author to split, and 1 MiB is the maintenance SLO. None of these may ever
 * discard an edit Yjs already applied: past the hard limit we only report
 * telemetry and demand a split, because refusing local updates loses work peers
 * have already seen.
 */

/** Recommended section size. Sections are split to land under this budget. */
export const SECTION_TARGET_ENCODED_BYTES = 256 * 1024;

/** Size at which the editor asks the author to split the section. */
export const SECTION_WARNING_ENCODED_BYTES = 768 * 1024;

/**
 * Hard per-section ceiling. Reaching it marks the section for the maintenance
 * rebalancer; a single top-level block over this size is reported rather than
 * split, because cutting inside a ProseMirror node would change the document.
 */
export const SECTION_HARD_ENCODED_BYTES = 1024 * 1024;
